import React from 'react'

type Props = {
  className?: string
  label: string
  accept?: string
  required?: boolean
  value: File | null
  onChange: (file: File | null) => void
  buttonText?: string
  hint?: React.ReactNode
  disabled?: boolean
  requiredColor?: string
  uploadedLabel?: string
}

const FilePickerField: React.FC<Props> = ({
  className,
  label,
  accept = '*/*',
  required = false,
  value,
  onChange,
  buttonText = 'Choose file',
  hint,
  disabled = false,
  requiredColor,
  uploadedLabel,
}) => {
  const handleInputChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files?.[0] || null
      event.target.value = ''
      onChange(file)
    },
    [onChange]
  )

  const displayButtonText = value || uploadedLabel ? 'Replace file' : buttonText
  const displayName = value?.name || uploadedLabel || 'No file selected'
  const nameColor = uploadedLabel ? '#166534' : undefined

  return (
    <div className={`file-picker-field${className ? ` ${className}` : ''}`}>
      <div className="field-label">
        {label}
        {required && <span style={{ color: requiredColor || '#dc2626', marginLeft: 4 }}>*</span>}
      </div>
      <div className="file-picker-row">
        <div className="file-picker-trigger">
          <button
            type="button"
            className="btn"
            disabled={disabled}
            aria-disabled={disabled}
          >
            {displayButtonText}
          </button>
          <input
            type="file"
            accept={accept}
            className="file-picker-input"
            onChange={handleInputChange}
            disabled={disabled}
          />
        </div>
        <span
          className="file-picker-name"
          style={{ color: nameColor, wordBreak: 'break-word', overflowWrap: 'anywhere' }}
        >
          {uploadedLabel ? `Uploaded: ${displayName}` : displayName}
        </span>
      </div>
      {hint && <div className="hint">{hint}</div>}
    </div>
  )
}

export default FilePickerField
